/**
 * Appends " card" suffix to credit card type name for accessibility purposes
 * when the card type contains "visa" (case-insensitive).
 *
 * @param {string} creditCardType - The credit card type (e.g., "Visa", "Mastercard", "American Express")
 * @returns {string} The card suffix to append - either " card" or empty string
 *
 * @example
 * getCardSuffix("Visa") // returns " card"
 * getCardSuffix("visa") // returns " card"
 * getCardSuffix("Mastercard") // returns ""
 */
export const getCardSuffix = creditCardType => {
  if (!creditCardType) return '';
  return creditCardType.toLowerCase().includes('visa') ? ' card' : '';
};

export default getCardSuffix;
